<template>
  <router-view> </router-view>
  <vue-progress-bar></vue-progress-bar>
</template>

<script>
export default {
  name: "App",
};
</script>
